module.exports = __webpack_public_path__ + "static/media/026.4536ba16.jpg";